import { createRoute } from '@tanstack/react-router'
import { t } from 'i18next'

import { StaticRouteParameter } from 'config/routing'
import { Overview } from 'domains/MediaPlatforms/IngestTasks'
import { mediaPlatformRoute } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform'
import { Structure } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/IngestTasks'

export const mediaPlatformIngestTasksRoute = createRoute({
  getParentRoute: () => mediaPlatformRoute,
  path: StaticRouteParameter.INGEST_TASKS,
  loader: () => ({
    crumb: t('entity:publishing.ingestTask', { count: 2 }),
  }),
})

export const mediaPlatformIngestTasksLayoutRoute = createRoute({
  getParentRoute: () => mediaPlatformIngestTasksRoute,
  id: 'mediaPlatforIngestTasksLayout',
  component: Structure,
})

type MediaPlatformIngestTasksOverviewSearch = {
  query?: string
}

export const mediaPlatformIngestTasksOverviewRoute = createRoute({
  getParentRoute: () => mediaPlatformIngestTasksLayoutRoute,
  path: '/',
  component: Overview,
  validateSearch: (search: Record<string, unknown>): MediaPlatformIngestTasksOverviewSearch => ({
    ...(!!search.query && typeof search.query === 'string' && { query: search.query }),
  }),
})
